export class ContentBlocks {
  blockId;
  blockName;
  cfgs;
  extras;
  fullBlockName;
  id;
  index;
  isContainer;
  values;
  placeholders;
  constructor(data) {
    this.blockId = data.block_id;
    this.blockName = data.block_name;
    this.cfgs = data.cfgs;
    this.extras = data.extras;
    this.fullBlockName = data.full_block_name;
    this.id = data.id;
    this.index = data.index;
    this.isContainer = data.is_container;
    this.values = data.values;
    this.placeholders = this.transformPlaceholders(data.placeholders);
  }
  transformPlaceholders(placeholders) {
    if (!placeholders || typeof placeholders !== "object") {
      return placeholders;
    }
    const transformedPlaceholders = {};
    Object.keys(placeholders).forEach((key) => {
      if (Array.isArray(placeholders[key])) {
        transformedPlaceholders[key] = placeholders[key].map((item) => new ContentBlocks(item).toJSON());
      } else {
        transformedPlaceholders[key] = this.transformPlaceholders(placeholders[key]);
      }
    });
    return transformedPlaceholders;
  }
  // это старый код, изменени 19.12.2023, если все работает, то можно удалить
  // private toCamelCase (data: any): any {
  //   for (const key in data) {
  //     if (Array.isArray(data[key])) {
  //       data[key] = data[key].map((d: any) => this.toCamelCase(d));
  //     } else {
  //       const newKey = key.replace(/_([a-z])/g, (g) => g[1].toUpperCase());
  //       data[newKey] = data[key];
  //       if (key !== newKey) {
  //         delete data[key];
  //       }
  //     }
  //   }
  //
  //   return data;
  // }
  toJSON() {
    return { ...this };
  }
}
export class ContentCmsPage {
  page;
  placeholders;
  layout;
  properties;
  constructor(data) {
    this.page = {
      alias: data.page.alias,
      navId: data.page.nav_id,
      imageId: data.page?.image_id || void 0,
      description: data.page.description,
      id: data.page.id,
      keywords: data.page.keywords,
      langId: data.page.lang_id,
      title: data.page.title,
      titleTag: data.page.title_tag
    };
    this.layout = {
      id: data.layout.id,
      name: data.layout.name
    };
    this.properties = data.properties;
    this.placeholders = {
      content: data.placeholders.content.map((t) => new ContentBlocks(t).toJSON())
    };
  }
  toJSON() {
    return { ...this };
  }
}
